module.exports = __webpack_public_path__ + "static/media/a74de012.jpg";